import PrtIcon from '@/components/atoms/PrtIcon/PrtIcon.vue'
import VueSticky from 'vue-sticky' // Es6 module

import axios from 'axios'

const casesDataUrl =
  'https://raw.githubusercontent.com/merito/koronawirus_frontend/master/src/data.js'
import addItem from '@/apollo/queries/addItem.gql'
export default {
  name: 'PrtHeader',
  directives: {
    sticky: VueSticky
  },
  mounted() {
    // this.getData()
  },
  methods: {
    // addItems() {
    //   this.isLoading = true
    //   this.$apollo
    //     .mutate({
    //       mutation: addItem,

    //       variables: {
    //         input: {
    //           productId: productId,
    //           quantity: this.qty,
    //           clientMutationId: 'test'
    //         }
    //       }
    //       // fetchPolicy: "no-cache" /
    //     })
    //     .then(result => {
    //       console.log('items added', result)
    //     })
    //     .catch(errors => {
    //       console.log('errors: ', errors)
    //     })
    // },

    getData() {
      axios.get(casesDataUrl).then(result => {
        const casesArrStr = result.data
          .split('export')[0]
          .replace('var points = ', '')

        const casesArr = eval(casesArrStr)
        const json = JSON.stringify(casesArr)
        console.log(json)
        //console.log(points)
      })
    }
  },

  components: {
    PrtIcon
  }
}
